import { render, staticRenderFns } from "./select-project-modal.vue?vue&type=template&id=20a878de&scoped=true&"
import script from "./select-project-modal.vue?vue&type=script&lang=js&"
export * from "./select-project-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a878de",
  null
  
)

export default component.exports